var error404 = {
    text:"Lo sentimos, pero no se ha encontrado la página que busca. Intente verificar la URL para ver un error, luego presione el botón de actualización en su navegador o intente ir a la pagina de inicio con esta ruta",    
    welcome: 'Inicio'
}
module.exports = error404

